import { useTranslation } from "react-i18next";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { Button, Form, Layout, TableColumnsType, TableProps, Typography } from 'antd';
import dayjs from "dayjs";
import { isEmpty, isNumber } from "lodash";
import { ChangeEvent, FunctionComponent, KeyboardEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormInput from "../../../../components/form-input/FormInput";
import PageHeader from "../../../../components/page-header/PageHeader";
import TableData from "../../../../components/table-data/TableData";
import { getVnPayPaymentList } from "../../../../service/transaction";
import { globalStore } from "../../../../stores/stores";
import { formatCurrency } from "../../../../utils/format";
import { formatCurrencyToVND } from "../../../../utils/functionUltils";
import FormFilter from "./filter-group/FormFilter";
import "./PaymentViaVnpay.scss";
type PaymentViaVnpayProps = {
	title?: string
}

const PaymentViaVnpay: FunctionComponent<PaymentViaVnpayProps> = ({ title }) => {
  const { t } = useTranslation();
	const navigate = useNavigate();
	const { personalInfo, reload } = globalStore();
	const [loading, setLoading] = useState<boolean>(true);
	const [showFilter, setShowFilter] = useState<boolean>(false);
	const [statusOrder, setStatusOrder] = useState<string>("desc");
	const [fieldSortOrder, setFieldSortOrder] = useState<string>("dateJoined");
	const [accountUsers, setAccountUsers] = useState<any[]>([]);
	const permissions = personalInfo?.permissions;
	const [dataOptions, setDataOptions] = useState({
		dataUnits: [],
		dataRoles: [],
		dataOffices: []
	})

	const [filterData, setFilterData] = useState<any>({
		universityId: null,
		status: null,
		approvedDate: null,
	});

	const [pageNumber, setPageNumber] = useState<number>(1)
	const [pageSize, setPageSize] = useState<number>(10)
	const [totalRecords, setTotalRecords] = useState<number>(0)
	const [searchValue, setSearchValue] = useState<string>('')

	const [form] = Form.useForm()

	const getListData = async () => {
		setLoading(true);
		const data = {
			page: pageNumber,
			size: pageSize,
			// sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
			courseId: filterData?.courseId,
			keyword: searchValue.trim() || undefined,
			fromDate: !isEmpty(filterData.approvedDate) && !isEmpty(filterData.approvedDate?.[0]) ? `${filterData.approvedDate?.[0]}T00:00:00.000Z` : null,
			endDate: !isEmpty(filterData.approvedDate) && !isEmpty(filterData.approvedDate?.[1]) ? `${filterData.approvedDate?.[1]}T00:00:00.000Z` : null,
			status: filterData.status,
		};

		await getVnPayPaymentList(data)
			.then((res) => {
				const { data } = res.data
				setAccountUsers(data.content)
				setTotalRecords(data.totalElements);
				setTimeout(() => {
					setLoading(false);
				}, 500);
			})
			.catch((err) => {
				if (err.response?.status === 403) {
					navigate("/error/403");
				} else {
					console.error(err);
				}
				setLoading(false);
			});
	};


	useEffect(() => {
		getListData()
	}, [pageSize, pageNumber, statusOrder, fieldSortOrder, filterData, localStorage.schoolManagement])


	const dataColumns: TableColumnsType<any> = [
		{
			title: "STT",
			dataIndex: "numericalOrder",
			key: "numericalOrder",
			align: "center",
			width: "5%",
			render: (_: any, record, index: number) => {
				return <div>{record.numericalOrder}</div>;
			},
		},
		{
			title: t("Mã giao dịch", "Mã giao dịch"),
			dataIndex: "transactionNo",
			key: "transactionNo",
			width: 150,
		},
		{
			title: t("Tên học viên", "Tên học viên"),
			dataIndex: "userName",
			key: "userName",
			width: 200,
		},
		{
			title: t("Tên khoá học", "Tên khoá học"),
			dataIndex: "orderName",
			key: "orderName",
		},
		{
			title: t("Thời gian", "Thời gian"),
			dataIndex: "payDate",
			key: "payDate",
			width: 200,
			render: (value: string) =>
				value ? dayjs(value).format("HH:mm:ss - DD/MM/YYYY") : "_",
		},

		{
			title: t("Giá khoá học", "Giá khoá học"),
			dataIndex: "amount",
			key: "amount",
			render: (value: number) => formatCurrencyToVND(value) || "_",
		},
		{
			title: t("Trạng thái", "Trạng thái"),
			dataIndex: "status",
			key: "status",
			render: (_: any, record, index: number) => {
				let statusText = "";
				let color = ""
				if (record?.status === 0) {
					statusText = t("Đang thực hiện", "Đang thực hiện");
					color = "#1677FF"
				}
				else if (record?.status === 1) {
					statusText = t("Thanh toán thành công", "Thanh toán thành công");
					color = "#52C41A"
				}
				else if (record?.status === 2) {
					statusText = t("Thanh toán thất bại", "Thanh toán thất bại");
					color = "#D9D9D9"
				}
				else if (record?.status === 3) {
					statusText = t("Thanh toán hết hạn", "Thanh toán hết hạn");
					color = "#FF4D4F"

				}


				return <div className="flex align-center gap-8">
					<div style={{ backgroundColor: color }} className="dot-icon" />
					{statusText}</div>;
			},
		}


	];

	const handleOpenFilter = () => {
		setShowFilter((showFilter) => !showFilter)
	}

	const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
		const { value, name } = e.target
		setSearchValue(value)
		if (value.length === 0) {
			setSearchValue("")
		}
	}

	const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
		if (e.key === 'Enter') {
			getListData()
		}
	}

	const handleSubmitSearch = () => {
		getListData()
	}


	const clearFilter = () => {
		form.resetFields()
	}


	const handleTableChange: TableProps["onChange"] = (
		pagination,
		filters,
		sorter: any
	) => {
		let data = ""
		if (!sorter.order) {
			data = 'desc'
			setFieldSortOrder("dateJoined");
		} else {
			data = sorter.order === "ascend"
				? "asc"
				: sorter.order === "descend"
					? "desc"
					: "";
			setFieldSortOrder(sorter.field);
		}
		setStatusOrder(data);
	};

	const handleChangeFilter = (value: any, name: string) => {
		setFilterData({ ...filterData, [name]: value });
	};

	const handleCloseFilter = () => {
		setShowFilter(false);
	};

	return (
		<Layout className="page-header-group payment-via-vnpay">
			<Form.Provider onFormFinish={(name, { values, forms }) => {
				if (name === 'createUser') {
					const { createUser } = forms
				}
				if (name === "filterForm") {
					getListData()
				}
			}}>
				<div className={`page-header-group--layout ${showFilter ? "open-filter" : ""}`}>
					<div className="table-header--wrapper justify-between pb-6">
						<div className="table-header--left">
							<PageHeader title={title} />
						</div>
						<div className="flex gap-8">
							<Button className={`filter-button ${showFilter ? 'open' : ''}`} onClick={handleOpenFilter}>
								<Typography.Text className="filter-text">{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
								{showFilter ? <UpOutlined /> : <DownOutlined />}
							</Button>
							<FormInput
								placeholder={t("Nhập tên khoá học", "Nhập tên khoá học")}
								value={searchValue}
								onChange={handleChangeInput}
								onKeyPress={handleSearch}
								afterPrefixIcon={
									<SearchOutlined onClick={handleSubmitSearch} />
								}
								style={{ width: "400px" }}
							/>
						</div>
					</div>
					<FormFilter
						handleCloseFilter={handleCloseFilter}
						clearFilter={clearFilter}
						form={form}
						showFilter={showFilter}
						filterData={filterData}
						setFilterData={setFilterData}
					/>
				</div>

				<TableData dataTable={accountUsers} dataColumns={dataColumns}
					setPageNumber={setPageNumber}
					setPageSize={setPageSize}
					pageNumber={pageNumber}
					pageSize={pageSize}
					pagination={true}
					loadingTable={loading}
					scroll={{ x: 1500, y: 600 }}
					totalRecords={totalRecords}
					handleTableChangeProps={handleTableChange}
				/>

			</Form.Provider>
		</Layout>
	);
};

export default PaymentViaVnpay;
